import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#B20FC0",
      "fill-rule": "evenodd",
      d: "M9.387.482a1.75 1.75 0 0 1 2.27 0l2.167 1.846a.25.25 0 0 0 .142.059l2.838.226a1.75 1.75 0 0 1 1.605 1.605l.227 2.838a.25.25 0 0 0 .058.142l1.847 2.167a1.75 1.75 0 0 1 0 2.27L18.694 13.8a.25.25 0 0 0-.058.142l-.227 2.838a1.75 1.75 0 0 1-1.605 1.605l-2.838.227a.25.25 0 0 0-.142.059l-2.166 1.846a1.75 1.75 0 0 1-2.27 0L7.22 18.672a.25.25 0 0 0-.142-.06l-2.838-.226a1.75 1.75 0 0 1-1.605-1.605l-.226-2.838a.25.25 0 0 0-.06-.142L.505 11.635a1.75 1.75 0 0 1 0-2.27l1.847-2.167a.25.25 0 0 0 .059-.142l.226-2.838a1.75 1.75 0 0 1 1.605-1.605l2.838-.226a.25.25 0 0 0 .142-.06L9.387.483Zm1.298 1.141a.25.25 0 0 0-.325 0L8.194 3.47a1.75 1.75 0 0 1-.996.413l-2.837.226a.25.25 0 0 0-.23.23l-.226 2.837a1.75 1.75 0 0 1-.413.996l-1.846 2.167a.25.25 0 0 0 0 .324l1.846 2.166c.24.28.384.629.413.996l.226 2.838a.25.25 0 0 0 .23.229l2.837.226c.367.03.716.174.996.413l2.166 1.846c.094.08.231.08.325 0l2.166-1.846a1.75 1.75 0 0 1 .996-.413l2.838-.226a.25.25 0 0 0 .229-.23l.226-2.837a1.75 1.75 0 0 1 .413-.996l1.846-2.166a.25.25 0 0 0 0-.325l-1.846-2.166a1.75 1.75 0 0 1-.413-.996l-.226-2.837a.25.25 0 0 0-.23-.23l-2.837-.226a1.75 1.75 0 0 1-.996-.413l-2.166-1.846Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#B20FC0",
      "fill-rule": "evenodd",
      d: "M14.803 8.095a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06l1.97 1.97 4.47-4.47a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "approved-clinic"}) } }